import store from "@/store";
import { hasOptionalPermission } from "@/Utils/permission";

function removeUnauthorizedElement(element, binding) {
  if (
    !hasOptionalPermission(store.state.permissions, binding.value) &&
    element.parentNode
  ) {
    element.parentNode.removeChild(element);
  }
}

export default {
  inserted: removeUnauthorizedElement,
};
